import angular from 'angular'

function studyCard() {
  return {
    restrict: 'E',
    replace: true,
    link: function(scope, elem, attrs) {
      scope.headingClass = attrs.headingClass
      scope.showShortLede = attrs.showShortLede
    },
    template: require('./_card-study.html')
  }
}

export default angular.module('directives.studyCard', [])
  .directive('studyCard', studyCard)
  .name